import { useState, FC } from "react";

import { Button } from "react-bootstrap";

import { DateTime } from "luxon";

import { ActionTenant, TenantFormModal } from "./form/TenantFormModal.tsx";
import { getDateFromIso } from "../../../_helpers/stringHelper";
import ColoredMarker from "../../../common/components/ColoredMarker";
import { IPerson } from "../../serviceOrdering/reducers";

interface IOrderTenantsProps {
  serviceId: string;
  tenantPeople?: Array<IPerson>;
  isInsuranceIssuedByAgency: boolean;
}

const OrderTenants: FC<IOrderTenantsProps> = ({
  serviceId,
  tenantPeople,
  isInsuranceIssuedByAgency,
}) => {
  const [showModal, setShowModal] = useState<{
    action: ActionTenant;
    tenantId?: string;
    open: boolean;
    data: any;
  }>({
    action: "edit",
    open: false,
    data: null,
  });
  return (
    <div className="d-flex flex-column gap-3">
      <TenantFormModal
        serviceId={serviceId}
        show={showModal.open}
        action={showModal.action}
        defaultValues={showModal.data}
        tenantId={showModal.tenantId}
        onHide={() =>
          setShowModal({
            action: "add",
            open: false,
            data: null,
          })
        }
      />
      <div className="d-flex gap-3 align-items-center">
        <label>Attestation remise en agence :</label>
        <span>
          {isInsuranceIssuedByAgency ? (
            <ColoredMarker color={"#13bfa4"}>Oui</ColoredMarker>
          ) : (
            <ColoredMarker color={"#e90118"}>Non</ColoredMarker>
          )}
        </span>
      </div>
      <div className="border-bottom" />
      {!tenantPeople || tenantPeople.length < 1 ? (
        <div>Aucun occupant renseigné.</div>
      ) : (
        tenantPeople.map((person: IPerson, index: number) => {
          return (
            <div key={index}>
              <div className={"position-relative"}>
                <div
                  className={
                    "position-absolute top-0 end-0 d-flex align-items-center"
                  }
                >
                  <Button
                    className="d-flex align-items-center me-2"
                    variant="outline-primary"
                    role="button"
                    onClick={() =>
                      setShowModal({
                        action: "edit",
                        tenantId: person.id,
                        open: true,
                        data: {
                          ...person,
                          leaseStartDate: person.lastTenant?.leaseEndDate,
                          leaseEndDate: person.lastTenant?.leaseEndDate,
                          rentalStartDate: person.lastTenant?.rentalStartDate,
                          rentalEndDate: person.lastTenant?.rentalEndDate,
                        },
                      })
                    }
                  >
                    <i className="pi pi-pencil" />
                  </Button>
                </div>
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex gap-2 align-items-center">
                    <span>
                      {person.lastname} {person.firstname}
                    </span>
                  </div>
                  <label>Email : {person?.email}</label>
                  <label>Tel : {person?.phone}</label>
                  {person.lastTenant?.leaseStartDate && (
                    <label>
                      Date de signature Bail :{" "}
                      {DateTime.fromISO(
                        person.lastTenant?.leaseStartDate
                      ).toFormat("EEEE dd MMMM")}
                    </label>
                  )}
                  {person.lastTenant?.leaseEndDate && (
                    <label>
                      Date de sortie :{" "}
                      {DateTime.fromISO(
                        person.lastTenant?.leaseEndDate
                      ).toFormat("EEEE dd MMMM")}
                    </label>
                  )}
                  {person.lastTenant?.rentalStartDate && (
                    <label>
                      Date d'entrée{" "}
                      <i className="bi bi-arrow-down-circle-fill text-success"></i>{" "}
                      : {getDateFromIso(person.lastTenant?.rentalStartDate)}
                    </label>
                  )}
                  {person.lastTenant?.rentalEndDate && (
                    <label>
                      Date de sortie{" "}
                      <i className="bi bi-arrow-up-circle-fill text-danger"></i>{" "}
                      : {getDateFromIso(person.lastTenant?.rentalEndDate)}
                    </label>
                  )}
                  <div className="border-bottom" />
                </div>
              </div>
            </div>
          );
        })
      )}

      {/* Add new tenant button */}
      <div className="d-flex justify-content-center mt-3">
        <Button
          className="d-flex align-items-center gap-2"
          variant="primary"
          onClick={() =>
            setShowModal({
              action: "add",
              open: true,
              data: null,
            })
          }
        >
          <i className="pi pi-plus" />
          Ajouter un nouveau occupant
        </Button>
      </div>
    </div>
  );
};

export default OrderTenants;
